
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wheels/transportbil/campervan",
      function () {
        return require("private-next-pages/wheels/transportbil/campervan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wheels/transportbil/campervan"])
      });
    }
  